
import '../css_styles/button_styles.css'
import background_img from './images/Aixelo_Background Graphic_Wave.png';
import logo from './images/LogoWhite.png';


import { useEffect, useState } from 'react';

function SelectWorkspace(props) {
  const [layout, setLayout] = useState({});

  useEffect(() => {
    // Disable body scrolling when the component mounts
    document.body.style.overflow = 'hidden';

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);



  useEffect(() => {
    function handleResize() {
        let window_height = window.innerHeight;
        let window_width = window.innerWidth;
        setLayout({window_height:window_height, window_width: window_width});
    }
    // Set initial height
    handleResize();
    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize);
    // Remove event listener on component unmount
    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []); // Empty dependency array ensures the effect only runs once

    const workspaces = props.workspaces.map((workspace) => {
        return (
          <button 
            key={workspace.name} 
            className='loginButton'
            id={workspace.uuid}
            style={{ 
              marginBottom: '10px',
              width: '400px'
            }}
            onClick={props.select} 
          >
            {workspace.name} 
          </button>
        );
      });

    return (
            <div style={{ overflow: 'hidden', width: '100vw', height: '100vh' }}>
                <img style={{ 
                            width: '100vw', 
                            height: '100vh', 
                            objectFit: 'cover' 
                    }} 
                    src={background_img} alt="background"/>
                <img style={{ 
                            position: 'absolute',
                            width: '250px',
                            top: '50px', 
                            left: '50%', 
                            transform: 'translateX(-50%)', 
                            zIndex: 1 
                    }} 
                    src={logo} alt="logo"/>
                <div style={{ 
                            position: 'absolute',
                            left: '50%',
                            width: '80%',
                            color: 'white',
                            fontSize: '34px',
                            transform: 'translateX(-50%)', 
                            top: '180px', 
                            zIndex: 1,
                            textAlign: 'center'
                    }} 
                >
                    <div style={{ 
                            marginBottom: '20px'}}>
                    Your <span style={{color: 'var(--aixelo-green)', font: '34px "Raleway", sans-serif'}}>Edison-4.0&#8482; </span>
                    accout is active for multiple worspaces, please select:
                    </div>
                    <div style={{ 
                            position: 'absolute',
                            overflow: 'auto',
                            height: layout.window_height-270,
                            left: '50%',
                            transform: 'translateX(-50%)'}}>
                                {workspaces}
                    </div>
                </div>
            </div>
        )
}

export default SelectWorkspace
